import type { ReactNode } from 'react';
import './EntryCard.scss';

interface EntryCardProps {
  /** Icon rendered inside the tinted tile at the top-left. */
  icon: ReactNode;
  title: string;
  subtitle: string;
  /** Heading element for the title — `h1` on a page whose card is the main heading. */
  headingLevel?: 'h1' | 'h2' | 'h3';
  children: ReactNode;
}

/**
 * EntryCard — the bordered, softly shadowed card with an icon tile, title
 * and small grey subtitle used for the visitor "entry points": the album-code
 * form (AlbumAssoc) and the sign-in panel on the login page. Keeping both on
 * one shell keeps them visually identical when they sit side by side.
 */
const EntryCard = ({ icon, title, subtitle, headingLevel = 'h3', children }: EntryCardProps) => {
  const Heading = headingLevel;
  return (
    <div className="entry-card-container">
      <div className="entry-card">
        <div className="entry-card-header">
          <div className="entry-card-icon">{icon}</div>
          <div>
            <Heading className="entry-card-title">{title}</Heading>
            <p className="entry-card-subtitle">{subtitle}</p>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default EntryCard;
